import React, { memo } from 'react';
import { formatDuration } from '@/components/pages/kiosk/tablet/TurnoverClock';
import { sanitizeToDate, useCurrentTime } from '@/util/timerHooks';

interface WaitingRoomTimerProps {
  since?: Date | string | number | null;
}

const WaitingRoomTimer = memo(function WaitingRoomTimer({ since }: WaitingRoomTimerProps) {
  const enteredAt = since == null ? NaN : (sanitizeToDate(since)?.getTime() ?? NaN);
  const hasEntryTime = Number.isFinite(enteredAt);
  const currentTime = useCurrentTime({ precision: 'second', paused: !hasEntryTime });

  if (!hasEntryTime) return null;

  const elapsedSeconds = Math.max(0, Math.floor((currentTime.getTime() - enteredAt) / 1000));

  return (
    <span role="timer" aria-label="Time in waiting room" style={{ fontVariantNumeric: 'tabular-nums' }}>
      {formatDuration(elapsedSeconds)}
    </span>
  );
});

export default WaitingRoomTimer;
